module.exports = __webpack_public_path__ + "img/天冬.878446b0.jpg";